import { useState } from 'react'
import { useProfile } from '../hooks/useProfile'

/**
 * プロフィールコンポーネント
 *
 * CoDMONの保護者情報・子ども・サービスを表示する。
 */
export function Profile() {
  const { profile, loading, syncing, error, syncFamily } = useProfile()
  const [successMessage, setSuccessMessage] = useState<string | null>(null)

  const handleSync = async () => {
    setSuccessMessage(null)
    const ok = await syncFamily()
    if (ok) {
      setSuccessMessage('家族情報を同期しました')
    }
  }

  if (loading) {
    return (
      <div className="profile">
        <h2>プロフィール</h2>
        <div className="loading">読み込み中...</div>
      </div>
    )
  }

  const hasCodmonProfile = profile?.codmonId != null
  const hasChildren = profile?.children && profile.children.length > 0

  // children を memberId でグループ化
  const childrenGrouped = new Map<string, { memberName: string; services: Array<{ serviceId: string; serviceName: string }> }>()
  if (profile?.children) {
    for (const child of profile.children) {
      const existing = childrenGrouped.get(child.memberId)
      if (existing) {
        existing.services.push({ serviceId: child.serviceId, serviceName: child.serviceName })
      } else {
        childrenGrouped.set(child.memberId, {
          memberName: child.memberName,
          services: [{ serviceId: child.serviceId, serviceName: child.serviceName }],
        })
      }
    }
  }

  return (
    <div className="profile">
      <h2>プロフィール</h2>

      {error && <div className="settings-error">{error}</div>}
      {successMessage && <div className="settings-success">{successMessage}</div>}

      {hasCodmonProfile ? (
        <>
          <div className="profile-section">
            <h3>保護者情報</h3>
            <div className="profile-parent-info">
              <div className="profile-info-row">
                <span className="profile-info-label">CoDMON ID</span>
                <span className="profile-info-value">{profile.codmonId}</span>
              </div>
              <div className="profile-info-row">
                <span className="profile-info-label">名前</span>
                <span className="profile-info-value">{profile.codmonName}</span>
              </div>
            </div>
          </div>

          {hasChildren && (
            <div className="profile-section">
              <h3>子ども・サービス</h3>
              <div className="profile-children">
                {Array.from(childrenGrouped.entries()).map(([memberId, child]) => (
                  <div key={memberId} className="profile-child-item">
                    <div className="profile-child-name">{child.memberName}</div>
                    <div className="profile-service-list">
                      {child.services.map((service) => (
                        <span key={service.serviceId} className="profile-service-badge">
                          {service.serviceName}
                        </span>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </>
      ) : (
        <div className="profile-section">
          <p className="profile-empty-message">
            CoDMONの家族情報がまだ同期されていません。
            下のボタンからCoDMONの家族情報を取得してください。
          </p>
        </div>
      )}

      <div className="profile-actions">
        <button
          className="button button-primary"
          onClick={handleSync}
          disabled={syncing}
        >
          {syncing ? '同期中...' : 'CoDMONの家族情報を同期する'}
        </button>
      </div>
    </div>
  )
}
